import { getColumnResizeProjectionFactory } from '@bingads-webui/projection-grid-column-resize';
import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';

const PLUGIN_NAME = 'campaignGridColumnResize';
export const campaignGridColumnResizePlugin = defineGridPlugin(
  PLUGIN_NAME,
  ['config', 'gridView'],
  (config, gridView, settings) => {
    // some other plugins also modify header html, ensure this is the last piped plugin
    gridView.once('didReload', () => {
      const plugin = getColumnResizeProjectionFactory()(PLUGIN_NAME, config, gridView, settings);
      gridView.pipeContentProjections(plugin);
    });
  }
);
